import styled from 'styled-components';

export const SiderWrapper = styled.div`
  margin-right: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  .admin-sider {
    height: 100%;
    border-radius: 8px;

    overflow: auto;

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .admin-sider::after,
  .admin-sider::before {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    border-radius: 8px;
    z-index: 1000;

    transition: box-shadow ease 0.2s;
  }

  .admin-sider.admin-sider__shadow-top::before {
    box-shadow: inset 0 50px 30px -60px var(--primary);
  }

  .admin-sider.admin-sider__shadow-bottom::after {
    box-shadow: inset 0 -50px 30px -60px var(--primary);
  }

  .profile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* align-items: flex-end; */
    padding: 8px 16px 0px 20px;
    flex: 1;
    @media (max-width: 1200px) {
      flex-direction: column;
      padding: unset;
      gap: 10px;
      margin-top: 14px;

      [name='logoLilac'] {
        scale: 0.7;
      }
    }

    .logo-area {
      svg {
        width: 110px;
        height: auto;
      }
    }
  }

  .profile-area {
    justify-content: flex-start;
    cursor: pointer;
  }
`;

export const AvatarWrapper = styled.div`
  border-radius: 50%;
  overflow: hidden;

  .ant-image-mask {
    display: none;
  }
`;

export const MenuWrapper = styled.div`
  position: relative;
  overflow: hidden;
  flex: 100%;
  width: 100%;
`;

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  width: 100%;

  .user-general-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;

    & span {
      line-height: 20px;
    }

    .user-name {
      font-weight: bold;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word;
    }

    .user-role {
      color: var(--dark-gray);
      font-size: 12px;
    }
  }

`;

export const MenuItemWithBadgeWrapper = styled.div<{
  $backgroundColor: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  sup {
    background-color: ${({ $backgroundColor }) => $backgroundColor} !important;
  }
`;
